import { useConfiguration, useLocale } from '@gov-nx/core/service';
import {
	PageCode,
	useNastaveniKontaktnichUdajuROSItemContext,
	useProfilROSDetailContext,
} from '@gov-nx/module/page';
import { ButtonGroupLayout, ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { ContactEmailView } from '../../nastaveni/kontaktni-udaje/ContactEmailView';
import { ContactPhoneView } from '../../nastaveni/kontaktni-udaje/ContactPhoneView';
import { UsePersonalContactsDialog } from '../../nastaveni/kontaktni-udaje/ros/UsePersonalContactsDialog';
import { getRosContactDetailRedirectUrl } from '../../../../../../utils/web/src/utils/getRosContactDetailRedirectUrl';

export const ContactDetailsView = () => {
	const { code, phone, email } = useNastaveniKontaktnichUdajuROSItemContext();
	const { ico, agendaCode } = useProfilROSDetailContext();
	const { t } = useLocale(PageCode['profil-ROS']);
	const { citizenPortalEditRosInfoUrl } = useConfiguration();

	const externalEditUrlWithParams = getRosContactDetailRedirectUrl({
		baseUrl: citizenPortalEditRosInfoUrl,
		ico,
		agendaCode,
	});

	return (
		<ContentLayout>
			<LayoutGap gap="m">
				<h3 className="text-(--text-secondary) text-body-l">
					{t('nadpis.kontaktni-udaje')}
				</h3>
				<p className="text-(--text-secondary) text-s">
					{t('popis.kontaktni-udaje')}
				</p>
				<div>
					<ContactEmailView
						code={code}
						externalEditUrl={externalEditUrlWithParams}
						{...email}
					/>
					<hr />
					<ContactPhoneView
						code={code}
						externalEditUrl={externalEditUrlWithParams}
						{...phone}
					/>
				</div>
			</LayoutGap>
			{!citizenPortalEditRosInfoUrl && (
				<ButtonGroupLayout>
					<UsePersonalContactsDialog
						code={code}
						ico={ico}
					/>
				</ButtonGroupLayout>
			)}
		</ContentLayout>
	);
};
